import React from "react";

const ComingSoon = () => (
  <div className="h-100 d-flex align-items-center justify-content-center">
    <div className="coming-soon">
      <h1>
        Coming Soon..
        <span className="dot">.</span>
      </h1>
    </div>
  </div>
);
export default ComingSoon;
